import * as React from "react";
import {Basket} from "../../../context/basket";
import {useContext, useEffect} from "react";
import Loader from "../../../layout/loader";
import RemoveCoupon from "../../../checkout/components/summary/actions/remove-coupon";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";
import {toast} from "react-toastify";


const Totals = (props) =>
{
    const basket = useContext(Basket);
    const basketData = basket?.data?.quote?.quote;
    const storeData = basket?.data?.quote?.store;
    const [checkoutMethod, setCheckoutMethod] = React.useState('checkout');
    const frequencyTotal = parseFloat(basketData?.subtotal - basketData?.one_off_total).toFixed(2);
    const frequencyWord = () => {
        let frequencyWord = 'every ';
        let hasFrequencySet = false;
        if (basketData?.items) {
            for (let item in basketData?.items) {
                if (basketData.items[item].is_frequency) {
                    if (hasFrequencySet) {
                        frequencyWord += ' + every ';
                    }
                    frequencyWord += basketData.items[item].month_data;
                    if (hasFrequencySet === false) {
                        hasFrequencySet = true;
                    }
                }
            }
        }

        return frequencyWord;
    }

    const getDiscountCode = () => {
        if (basketData.discount_total > 0) {
            const couponCodes = JSON.parse(basketData.discount_codes);
            if (couponCodes.length === 1) {
                return couponCodes;
            } else if (couponCodes.length > 1) {
                return couponCodes.join();
            }
        }

        return '';
    }

    const removeCoupon = (e) => {
        props.setLoader(true);

        RemoveCoupon().then((res) => {
            if (res.data.error) {
                toast.error(res.data.message);
                props.setLoader(false);
            } else {
                toast.success(res.data.message);
                basket.updateBasketReturn().then(() => {
                    props.setLoader(false);
                });
            }
        });
    }

    useEffect(() => {
        if (basket?.data?.is_sub_update === true) {
            setCheckoutMethod('update');
        }
    });

    return <div className="basket-total-wrapper">
        {basket.data === null
            || typeof basket.data === 'undefined' && (
                <Loader />
            )
        }
        {basket.data !== null
            && typeof basket.data !== 'undefined' && (
                <Box className="totals-wrapper">
                    <Box className="header">
                        {checkoutMethod === 'update' && (
                            <h2 className="margin-y-0">Updated order overview</h2>
                        )}
                        {checkoutMethod === 'checkout' && (
                            <h2 className="margin-y-0">Order overview</h2>
                        )}
                    </Box>
                    <Box className="subtotal-wrapper">
                        <Grid container className="total-monthly">
                            <Grid xs={6} className="basket-monthly-title">
                                <h3 className="margin-bottom-0">Subscription</h3>
                                <small className="capitalize dk-grey">{frequencyWord()}</small>
                            </Grid>
                            <Grid xs={6} className="basket-monthly-value flex-end">
                                <h3>{storeData.currency.symbol}{frequencyTotal}</h3>
                            </Grid>
                        </Grid>
                        {basketData.one_off_total > 0 && (
                            <Grid container className="one-off-total margin-bottom-0">
                                <Grid xs={6} className="one-off-total-title">
                                    {checkoutMethod === 'update' && (
                                        <h3>Once off next subscription payment</h3>
                                    )}
                                    {checkoutMethod === 'checkout' && (
                                        <h3>One off payment</h3>
                                    )}
                                </Grid>
                                <Grid xs={6} className="one-of-total-value flex-end">
                                    <h3>{storeData.currency.symbol}{basketData.one_off_total}</h3>
                                </Grid>
                            </Grid>
                        )}
                        <Grid container className="subtotal">
                            <Grid xs={6} className="subtotal-title">
                                <p className="margin-bottom-0">Subtotal</p>
                                <small className="dk-grey">Includes VAT</small>
                            </Grid>
                            <Grid xs={6} className="subtotal-value flex-end">
                                <p className="margin-bottom-0 line-height-2">{storeData.currency.symbol}{basketData.subtotal}</p>
                            </Grid>
                        </Grid>
                        <Grid container className="shipping-total">
                            <Grid xs={6} className="shipping-total-title">
                                <p className="margin-top-0 line-height-2">Shipping</p>
                            </Grid>
                            <Grid xs={6} className="shipping-total-value flex-end">
                                <p className="margin-top-0 line-height-2">{storeData.currency.symbol}{basketData.shipping_total}</p>
                            </Grid>
                        </Grid>
                        <Grid container className="discount-total">
                            <Grid xs={6} className="discount-total-title">
                                <h3 className="margin-bottom-0 line-height-2">{'Discount'}</h3>
                            </Grid>
                            <Grid xs={6} className="discount-total-value flex-end">
                                <h3 className="margin-bottom-0">{storeData.currency.symbol}{basketData.discount_total}</h3>
                            </Grid>
                        </Grid>
                            {getDiscountCode() && (
                                <small
                                    className="margin-bottom-1 block">
                                <Grid container>
                                    <Grid xs={6} className="uppercase dk-grey">
                                        {getDiscountCode()}
                                    </Grid>
                                    <Grid xs={6} className="flex-end">
                                        <a className="slide-link primary" onClick={removeCoupon} data-replace="Remove"><span>Remove</span></a>
                                    </Grid>
                                </Grid></small>
                            )}
                    </Box>
                    <Box className="totals-wrapper">
                        <Grid container className="basket-total">
                            <Grid xs={6} className="basket-total-title">
                                {checkoutMethod === 'update' && (
                                    <h3 className="margin-top-0 line-height-2">Total next subscription</h3>
                                )}
                                {checkoutMethod === 'checkout' && (
                                    <h3 className="margin-top-0 line-height-2">Total Today</h3>
                                )}
                            </Grid>
                            <Grid xs={6} className="basket-total-value flex-end">
                                <h3 className="margin-top-0">{storeData.currency.symbol}{basketData.grand_total}</h3>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            )
        }
    </div>
}

export default Totals;